interface DelegationCardProps {
  id: string;
  level: number;
  name: string;
  description: string;
  isSelected?: boolean;
  isVoted?: boolean;
  disabled?: boolean;
  onClick?: () => void;
}

export const DelegationCard = ({
  id,
  name,
  description,
  isSelected = false,
  isVoted = false,
  disabled = false,
  onClick,
}: Omit<DelegationCardProps, 'level'>) => {
  const handleClick = () => {
    if (!disabled && onClick) {
      onClick();
    }
  };

  const imageUrl = `/apps/delegation-poker/dp-card-${id}.png`;

  return (
    <div
      onClick={handleClick}
      className={`
        relative w-full max-w-[160px] cursor-pointer transition-all
        ${disabled ? 'cursor-not-allowed opacity-50' : 'hover:scale-105'}
        ${isSelected ? 'ring-4 ring-primary' : ''}
        ${isVoted ? 'ring-2 ring-green-500' : ''}
      `}
    >
      {/* Card Container */}
      <div className="relative aspect-[2/3] w-full overflow-hidden rounded-lg border-2 border-border bg-card shadow-lg">
        {/* Card Image */}
        <img
          src={imageUrl}
          alt={`${name}: ${description}`}
          title={description}
          className="h-full w-full object-cover"
          onError={(e) => {
            // Fallback to text if image fails to load
            (e.target as HTMLImageElement).style.display = 'none';
          }}
        />

        {/* Title - Centered slightly below middle */}
        <div className="absolute inset-x-0 top-1/2 translate-y-2 transform text-center pointer-events-none">
          <p className="text-sm font-bold text-black drop-shadow-[0_2px_4px_rgba(255,255,255,0.8)]">{name}</p>
        </div>

        {/* Description - Bottom */}
        <div className="absolute inset-x-0 bottom-2 px-2 pointer-events-none">
          <p className="text-center text-xs text-white drop-shadow-md line-clamp-2">{description}</p>
        </div>

        {/* Selected Indicator */}
        {isSelected && (
          <div className="absolute inset-0 bg-primary/10 pointer-events-none ring-4 ring-primary" />
        )}

        {/* Voted Indicator */}
        {isVoted && (
          <div className="absolute inset-0 flex items-center justify-center bg-green-500/20 pointer-events-none">
            <span className="text-2xl">✓</span>
          </div>
        )}
      </div>
    </div>
  );
};
